export const FETCH_FOLDERS = 'FETCH_FOLDERS';
export const SET_FOLDERS = 'SET_FOLDERS';
export const GET_FOLDER = 'GET_FOLDER';
export const SET_FOLDER = 'SET_FOLDER';
export const ADD_FOLDER = 'ADD_FOLDER';
export const UPDATE_FOLDER = 'UPDATE_FOLDER';